export const ROUTE_PATH = {
  // Base tenant
  TENANT_ROOT: "/tenant/:tenantId",

  // App routes
  HOME: "/tenant/:tenantId",
  FOLDERS: "/tenant/:tenantId/folders",
  FOLDER: "/tenant/:tenantId/folders/:id",
  IMPORT: "/tenant/:tenantId/import",

  // Routes d'erreur tenant-scoped
  TENANT_ERROR_403: "/tenant/:tenantId/error/403",
  TENANT_ERROR_404: "/tenant/:tenantId/error/404",
  TENANT_ERROR_500: "/tenant/:tenantId/error/500",

  // Error routes
  ERROR_403: "/forbidden",
  ERROR_404: "/notFound",
  ERROR_500: "/error",
} as const;

export type RoutePath = (typeof ROUTE_PATH)[keyof typeof ROUTE_PATH];
